import { Checkbox, FormControlLabel, withStyles } from "@material-ui/core";
import React from "react";

const CheckBoxQ = ({ name, checked, onChange, label, disabled }) => {
  const GreenCheckbox = withStyles({
    root: {
      color: "var(--primary-green)",
      "&$checked": {
        color: "var(--primary-green)",
      },
    },
    checked: {},
  })(Checkbox);

  return label ? (
    <FormControlLabel
      control={
        <GreenCheckbox
          name={name}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
      }
      label={label}
      style={{
        fontFamily: "Montserrat",
        color: "#333",
        fontWeight: "bold",
        marginLeft: 0,
        display: "flex",
        alignItems: "center",
      }}
    />
  ) : (
    <div
      style={{
        display: "flex",
        alignItems: "center", 
      }}
    >
      <GreenCheckbox
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};

export default CheckBoxQ;
